'use client';

import SiteBanner from '@/components/common/banner/SiteBanner';
import { HOME_BANNER_POSITION_BY_TYPE } from '@/constants/banner';

const MobileBanner = () => {
  return (
    <SiteBanner
      positionId={HOME_BANNER_POSITION_BY_TYPE.mobile}
      className="block md:hidden flex-none !pb-5 lg:!pb-5"
    />
  );
};

export default MobileBanner;
